import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GymProvider } from './Components/GymContext'; // Import the provider

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 💡 Wrap App here so context is available globally */}
    <GymProvider>
      <App />
    </GymProvider>
  </React.StrictMode>
);